/**
 * Customer account — App Proxy client for cancel/edit self-service (CA-009)
 * and delivery visibility GET endpoints (CA-delivery-v1).
 * POST paths: /apps/{subpath}/orders/{orderId}/cancel|edit/preview|commit
 * GET paths:  /apps/{subpath}/orders/{orderId}/delivery
 *             /apps/{subpath}/delivery/today
 */
(function (global) {
  'use strict';

  function parseProxyConfig(root) {
    var el = root && root.querySelector('[data-order-history-bootstrap]');
    if (!el) el = root && root.querySelector('[data-delivery-root]');
    if (!el) el = root && root.querySelector('[data-delivery-activity-dock]');
    if (!el) el = root && root.querySelector('[data-delivery-today-overview]');
    if (!el) el = root && root.querySelector('[data-delivery-float]');
    var subpath = (el && el.getAttribute('data-app-proxy-subpath')) || 'paymentstatussync';
    return { subpath: subpath };
  }

  function buildPath(subpath, orderId, operation) {
    return (
      '/apps/' +
      encodeURIComponent(subpath) +
      '/orders/' +
      encodeURIComponent(String(orderId)) +
      '/' +
      operation
    );
  }

  function buildRootPath(subpath, path) {
    return '/apps/' + encodeURIComponent(subpath) + '/' + path;
  }

  function parseJsonResponse(res) {
    return res.text().then(function (text) {
      var body = {};
      if (text) {
        try {
          body = JSON.parse(text);
        } catch (e) {
          body = { success: false, blockMessage: text };
        }
      }
      if (!res.ok && body.success !== false) {
        body.success = false;
        body._httpStatus = res.status;
        if (!body.blockMessage) {
          body.blockMessage = 'Request failed (' + res.status + ')';
        }
      }
      return body;
    });
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload || {})
    }).then(parseJsonResponse);
  }

  function post(root, orderId, operation, payload) {
    var config = parseProxyConfig(root);
    return postJson(buildPath(config.subpath, orderId, operation), payload);
  }

  /** POST JSON to /apps/{subpath}/{path} (routes not scoped to one order, e.g. attachments/*). */
  function postRoot(root, path, payload) {
    var config = parseProxyConfig(root);
    return postJson(buildRootPath(config.subpath, path), payload);
  }

  function get(root, path) {
    var config = parseProxyConfig(root);
    var url = buildRootPath(config.subpath, path);
    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(parseJsonResponse);
  }

  function previewCancel(root, orderId) {
    return post(root, orderId, 'cancel/preview', {});
  }

  function commitCancel(root, orderId, options) {
    var body = {};
    if (options && options.staffNote) body.staffNote = options.staffNote;
    return post(root, orderId, 'cancel/commit', body);
  }

  function previewEdit(root, orderId) {
    return post(root, orderId, 'edit/preview', {});
  }

  function commitEdit(root, orderId, lineEdits, idempotencyKey, options) {
    var body = {
      lineEdits: lineEdits,
      idempotencyKey: idempotencyKey
    };
    if (options && options.notifyCustomer != null) body.notifyCustomer = options.notifyCustomer;
    if (options && options.staffNote) body.staffNote = options.staffNote;
    return post(root, orderId, 'edit/commit', body);
  }

  function getDelivery(root, orderId) {
    return get(root, 'orders/' + encodeURIComponent(String(orderId)) + '/delivery');
  }

  function getTodayOverview(root) {
    return get(root, 'delivery/today');
  }

  function getActivityOverview(root) {
    return get(root, 'delivery/activity');
  }

  global.BmwCustomerAccount = global.BmwCustomerAccount || {};
  global.BmwCustomerAccount.proxyClient = {
    parseProxyConfig: parseProxyConfig,
    previewCancel: previewCancel,
    commitCancel: commitCancel,
    previewEdit: previewEdit,
    commitEdit: commitEdit,
    getDelivery: getDelivery,
    getTodayOverview: getTodayOverview,
    getActivityOverview: getActivityOverview,
    postRoot: postRoot
  };
})(typeof window !== 'undefined' ? window : this);
